import { ParsedTelemetry, TelemetryFormat } from "../types"
import { parseSrtCues, srtSampleRate } from "./srt"

const fieldPattern = /([a-z_]+)\s*:\s*(-?\d+(?:\.\d+)?)/g

export const parseDjiBrackets = (text: string): ParsedTelemetry => {
    const cues = parseSrtCues(text)
    const events = cues.map((cue) => {
        const fields: Record<string, number | undefined> = {}
        for (const line of cue.lines) {
            for (const match of line.matchAll(fieldPattern)) {
                fields[match[1]] = Number(match[2])
            }
        }
        return {
            timestamp: cue.start,
            longitude: fields.longitude ?? NaN,
            latitude: fields.latitude ?? NaN,
            height: fields.abs_alt ?? fields.altitude ?? NaN,
            elevation: fields.rel_alt,
            yaw: fields.gb_yaw ?? NaN,
            pitch: fields.gb_pitch ?? NaN,
            roll: fields.gb_roll ?? NaN,
            fov: fields.focal_len,
        }
    })
    // the final embedded cue is often truncated mid-payload, so its event is unreliable
    events.pop()
    return { events, samplesPerSecond: srtSampleRate(cues) }
}

export const dji = {
    name: "dji",
    matches: (prefix) => prefix.includes("<font") && prefix.includes("[latitude"),
    parse: parseDjiBrackets,
} satisfies TelemetryFormat
